import { Theme } from "../../../../components/constants";

export default {
	mainContainer: {
		display: 'flex', 
		flexDirection: 'column', 
		justifyContent: 'center', 
		alignItems: 'center', 
		gap: '30px'
	},
	buttonPadding: {
		padding: '10px 25px', 
		marginTop: '20px'
	},
	leftContainer: {
		display: 'flex', 
		flexDirection: 'column', 
		justifyContent: 'center', 
		alignItems: 'center', 
		gap: '10px'
	},
	padding: {
		padding: '10px'
	},
	disabledText: {
		fontSize: "16px", 
		color: Theme.DISABLED_TEXT
	},
	textAlignCenter: {
		textAlign: 'center'
	},
	rightContainer: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '25px'
	},
	text: {
		fontSize: "16px", 
		color: Theme.TEXT_PRIMARY_BLACK
	},
	qrImgStyles: {
		width: "300px",
		height: "300px",
	}

}